// pages/MemberRegistrationPage.js

import React, { useState } from "react";
import { Link } from "react-router-dom";
import useMemberRegistration from "../hooks/useMemberRegistration";
import "../styles/MemberRegistrationPage.css";

function MemberRegistrationPage() {
  const { cities, districts, loading, error, updateDistricts, registerMember } =
    useMemberRegistration();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobile: "",
    city: "",
    district: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (formErrors[name]) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleCityChange = (e) => {
    const cityName = e.target.value;
    setFormData((prev) => ({
      ...prev,
      city: cityName,
      district: "",
    }));
    updateDistricts(cityName);
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = "الاسم مطلوب";
    } else if (!/[a-zA-Z\u0600-\u06FF]/.test(formData.name)) {
      errors.name = "الاسم يجب أن يحتوي على حروف";
    }

    if (!formData.email.trim()) {
      errors.email = "البريد الإلكتروني مطلوب";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "البريد الإلكتروني غير صالح";
    }

    if (!formData.password) {
      errors.password = "كلمة المرور مطلوبة";
    } else if (formData.password.length < 6) {
      errors.password = "كلمة المرور يجب أن تكون 6 أحرف على الأقل";
    }

    if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = "كلمات المرور غير متطابقة";
    }

    if (!formData.mobile) {
      errors.mobile = "رقم الجوال مطلوب";
    } else if (!/^05[0-9]{8}$/.test(formData.mobile)) {
      errors.mobile =
        "رقم الجوال غير صحيح. يجب أن يبدأ بـ 05 ويتكون من 10 أرقام.";
    }

    if (!formData.city) {
      errors.city = "يرجى اختيار المدينة";
    }

    if (!formData.district) {
      errors.district = "يرجى اختيار الحي";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      await registerMember(formData);
      setSuccessMsg("success");
    } catch (error) {
      // سيظهر في الـUI تلقائياً من hook
    }
  };

  return (
    <div className="registration-container">
      <div className="registration-page">
        <div className="registration-box">
          {/* Logo */}
          <div className="logo-section">
            <img
              src={process.env.PUBLIC_URL + "/matajer.png"}
              alt="Matajer Logo"
              className="app-logo"
            />
          </div>

          {/* Header - hidden when success */}
          {!successMsg && (
            <div className="reg-header">
              <h1 className="page-title">تسجيل عضوية جديدة</h1>
              <p className="page-subtitle">
                انضم إلى عضو متاجر الحي واستفد من المزايا الحصرية
              </p>
            </div>
          )}

          {/* Program Info Banner - hidden when success */}
          {!successMsg && (
            <div className="program-info-banner">
              <div className="program-info-content">
                <p className="program-info-text">
                  برنامج مجاني لأهالي الحي يتيح لك المساهمة
                  في تطوير منصة متاجر حيك / مدينتك.
                </p>
                <p className="program-info-text">
                  تحسب لك نقاط تلقائياً عند تسجيل الأنشطة،
                  وتصرف النقاط كوبونات حقيقية من محلات حيك.
                </p>
              </div>
              <div className="program-info-flow">
                <span className="flow-step">أنشطة بسيطة</span>
                <span className="flow-arrow">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                </span>
                <span className="flow-step flow-step--accent">نقاط تلقائية</span>
                <span className="flow-arrow">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                </span>
                <span className="flow-step flow-step--success">كوبونات حقيقية</span>
              </div>
            </div>
          )}

          {successMsg && (
            <div className="success-screen">
              <div className="success-icon-wrapper">
                <svg
                  className="success-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>

              <h2 className="success-title">
                شكراً لانضمامك لبرنامج عضو متاجر الحي
              </h2>

              <div className="success-steps">
                <div className="success-step">
                  <div className="step-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                  </div>
                  <p>
                    سنراجع طلبك ونُفعّل حسابك خلال <strong>24 ساعة</strong>
                  </p>
                </div>

                <div className="success-step">
                  <div className="step-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </div>
                  <p>ستصلك رسالة تأكيد على بريدك الإلكتروني عند تفعيل الحساب</p>
                </div>

                <div className="success-step">
                  <div className="step-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </div>
                  <p>بعدها تقدر تبدأ تكسب النقاط مباشرة</p>
                </div>
              </div>

              <p className="success-emoji">نسعد بانضمامك 🎉</p>

            </div>
          )}

          {/* Form - hidden when success */}
          {!successMsg && (
            <>
              {/* Alerts */}
              {error && (
                <div className="alert-box alert-error">
                  <svg
                    className="alert-icon"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{error}</span>
                </div>
              )}

              {/* Form */}
              <form onSubmit={handleSubmit} className="registration-form">
                {/* Full Name */}
                <div className="form-group">
                  <label>الاسم</label>
                  <div className="input-wrapper">
                    <svg
                      className="input-icon"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="أدخل اسمك"
                      className={`form-control ${formErrors.name ? "error" : ""}`}
                    />
                  </div>
                  {formErrors.name && (
                    <span className="field-error">{formErrors.name}</span>
                  )}
                </div>

                {/* Email */}
                <div className="form-group">
                  <label>البريد الإلكتروني</label>
                  <div className="input-wrapper">
                    <svg
                      className="input-icon"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="example@email.com"
                      className={`form-control ${formErrors.email ? "error" : ""}`}
                      dir="ltr"
                    />
                  </div>
                  {formErrors.email && (
                    <span className="field-error">{formErrors.email}</span>
                  )}
                </div>

                {/* Password Row */}
                <div className="form-row">
                  <div className="form-group">
                    <label>كلمة المرور</label>
                    <div className="input-wrapper">
                      <svg
                        className="input-icon"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="اختر كلمة مرور"
                        className={`form-control ${formErrors.password ? "error" : ""}`}
                        dir="ltr"
                      />
                    </div>
                    {formErrors.password && (
                      <span className="field-error">{formErrors.password}</span>
                    )}
                    <span className="field-hint">مثال: Abc@12</span>
                  </div>

                  <div className="form-group">
                    <label>تأكيد كلمة المرور</label>
                    <div className="input-wrapper">
                      <svg
                        className="input-icon"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l3.293-3.293z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <input
                        type="password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        placeholder="أعد كتابة كلمة المرور"
                        className={`form-control ${formErrors.confirmPassword ? "error" : ""}`}
                        dir="ltr"
                      />
                    </div>
                    {formErrors.confirmPassword && (
                      <span className="field-error">
                        {formErrors.confirmPassword}
                      </span>
                    )}
                  </div>
                </div>

                {/* Mobile */}
                <div className="form-group">
                  <label>رقم الجوال</label>
                  <div className="input-wrapper">
                    <svg
                      className="input-icon"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      placeholder="05xxxxxxxx"
                      className={`form-control ${formErrors.mobile ? "error" : ""}`}
                      dir="ltr"
                    />
                  </div>
                  {formErrors.mobile && (
                    <span className="field-error">{formErrors.mobile}</span>
                  )}
                </div>

                {/* City & District Row */}
                <div className="form-row">
                  <div className="form-group">
                    <label>المدينة</label>
                    <div className="input-wrapper select-wrapper">
                      <svg
                        className="input-icon"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <select
                        name="city"
                        value={formData.city}
                        onChange={handleCityChange}
                        className={`form-control form-select ${!formData.city ? "placeholder-shown" : ""} ${formErrors.city ? "error" : ""}`}
                      >
                        <option value="">اختر المدينة</option>
                        {cities.map((city) => (
                          <option key={city} value={city}>
                            {city}
                          </option>
                        ))}
                      </select>
                    </div>
                    {formErrors.city && (
                      <span className="field-error">{formErrors.city}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>الحي</label>
                    <div className="input-wrapper select-wrapper">
                      <svg
                        className="input-icon"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <select
                        name="district"
                        value={formData.district}
                        onChange={handleInputChange}
                        disabled={!formData.city}
                        className={`form-control form-select ${!formData.district ? "placeholder-shown" : ""} ${formErrors.district ? "error" : ""}`}
                      >
                        <option value="">
                          {formData.city ? "اختر الحي" : "اختر المدينة أولاً"}
                        </option>
                        {districts.map((district) => (
                          <option key={district} value={district}>
                            {district}
                          </option>
                        ))}
                      </select>
                    </div>
                    {formErrors.district && (
                      <span className="field-error">{formErrors.district}</span>
                    )}
                  </div>
                </div>

                {/* Submit Button */}
                <div className="form-actions">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        جاري التسجيل
                        <span className="loading-spinner"></span>
                      </>
                    ) : (
                      "تسجيل العضوية"
                    )}
                  </button>
                </div>

                {/* Login Link */}
                <div className="form-footer-links">
                  <div className="login-prompt">
                    <span>هل لديك حساب بالفعل؟</span>
                    <Link to="/login" className="btn-link-accent">
                      تسجيل الدخول
                    </Link>
                  </div>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MemberRegistrationPage;
